import React, { useContext } from 'react';
import { CmicContext } from 'src/taskpane/context/CmicContext';
import { MessageBar, MessageBarType } from '@fluentui/react';
import './styles.scss';

const Toast = () => {
    const { showToast, setShowToast } = useContext(CmicContext);
    if (!showToast.isVisible) return null;
    return (
        <div className='toast-container'>
            <MessageBar
                messageBarType={showToast.type || MessageBarType.error}
                isMultiline={false}
                truncated
                onDismiss={() =>
                    setShowToast({
                        isVisible: false,
                        type: null,
                        msg: '',
                    })
                }
            >
                {showToast.msg}
            </MessageBar>
        </div>
    );
};

export default Toast;